import { type ClientInferRequest } from "@ts-rest/core";

import { client } from "../client";
import { type apiContract } from "../contract";

type GetSessionRequest = ClientInferRequest<
  typeof apiContract.v1.pos.tills.getSessionById
>;

export type GetSessionArgs = GetSessionRequest["params"] & {
  options?: GetSessionRequest["query"];
};

export async function getSession({
  sessionId,
  tillId,
  options
}: GetSessionArgs) {
  const response = await client.v1.pos.tills.getSessionById({
    params: {
      sessionId,
      tillId
    },
    query: options
  });

  if (response.status === 200) {
    return response.body;
  }

  throw response;
}

type GetSessionsRequest = ClientInferRequest<
  typeof apiContract.v1.pos.tills.getSessions
>;

export type GetSessionsArgs = GetSessionsRequest["params"] & {
  options?: GetSessionsRequest["query"];
};

export async function getSessions({ tillId, options }: GetSessionsArgs) {
  const response = await client.v1.pos.tills.getSessions({
    params: { tillId },
    query: options
  });

  if (response.status === 200) {
    return response.body;
  }

  throw response;
}

type CreateSessionRequest = ClientInferRequest<
  typeof apiContract.v1.pos.tills.createSession
>;

type CreateSessionArgs = CreateSessionRequest["params"] &
  CreateSessionRequest["body"];

export async function createSession({ tillId, ...body }: CreateSessionArgs) {
  const response = await client.v1.pos.tills.createSession({
    params: { tillId },
    body
  });

  if (response.status === 201) {
    return response.body;
  }

  throw response;
}

type UpdateSessionRequest = ClientInferRequest<
  typeof apiContract.v1.pos.tills.closeSession
>;

export type UpdateSessionArgs = UpdateSessionRequest["params"] &
  UpdateSessionRequest["body"];

export async function updateSession({
  sessionId,
  tillId,
  ...body
}: UpdateSessionArgs) {
  const response = await client.v1.pos.tills.closeSession({
    params: { sessionId, tillId },
    body
  });

  if (response.status === 204) {
    return response.body;
  }

  throw response;
}
